import PropTypes from 'prop-types';
import React, {Component} from 'react';

//helpers
import {styleable} from 'decorators';

//styles
import {Caption, Circle, ClickableArea, RadioButton} from './styles';

const getOnClick =
  ({disabled, onChange}) =>
  () => {
    if (!disabled && typeof onChange === 'function') {
      onChange();
    }
  };
@styleable
class RadioButtonComponent extends Component {
  static defaultProps = {
    checked: false,
    design: 'default',
    disabled: false
  };

  static propTypes = {
    caption: PropTypes.node,
    checked: PropTypes.bool,
    design: PropTypes.oneOf(['default', 'fill-line']),
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    height: PropTypes.number,
    dataTestId: PropTypes.string
  };

  render() {
    const {caption, checked, design, disabled, onChange, height} = this.props;

    return (
      <RadioButton disabled={disabled} design={design}>
        <ClickableArea
          height={height}
          role="radio"
          aria-checked={checked}
          disabled={disabled}
          onClick={getOnClick({disabled, onChange})}
        >
          <Circle checked={checked} />
          {caption && <Caption>{caption}</Caption>}
        </ClickableArea>
      </RadioButton>
    );
  }
}

export default RadioButtonComponent;
